import React, { Component } from 'react';
import FakeData from '.././fake-data';
import ReactDOM from 'react-dom';
import { Link, Redirect } from 'react-router-dom';
import { Helmet } from "react-helmet";
import './LEAGUE.css';

import CreateTourn from './CreatePages/TOURNS';

import { GroupGames, GroupStand } from '.././components/GMC';

import { ConfirmModal, BannerShimmer, FeedBackPopUp, PastClubsView, EmptyState, LoadingState, PostItem, ClubItem, GlobalTMFeeds, GlobalTMForm, LeagueSplitView, SetTournGameModal, ItemPicker, Modal, ComboBox, PhotoAddModal, TagView, MomentPickerModal, EditGameModal, PlayOffView } from '.././components/Common';
import AboutView from '.././components/About';
import Photos from '.././components/Photos';
import Videos from '.././components/Videos';
import Games from '.././components/Games';
import Settings from '.././components/Settings';
import InternalNoticeCenter from '.././components/InternalNoticeCenter';
import {
	BannerReportView
} from './Admin';

const Trojan = window.Trojan;
const Croppie = window.Croppie;
const $ = window.$;
const jQuery = window.jQuery;

class HomeView extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			id: this.props.match.params.leagueId,
			league: { id: null, teams: { current: [] } },
			error: false,
			activeTab: 'clubs',
			tabs: this.props.withGuest ? [
				{ val: "about", key: "About", notices: [] },
				//{ val: "apply", key: "Apply", notices: [] }
			] : [
					{ val: "timeline", key: "Timeline", notices: [] },
					{ val: "games", key: "Games", notices: [] },
					{ val: "about", key: "About", notices: [] },
					{ val: "clubs", key: "Clubs", notices: [] },
					{ val: "stats", key: "Stats", notices: [] },
					{ val: "photos", key: "Photos", notices: [] },
					{ val: "videos", key: "Videos", notices: [] },
					{ val: "notice", key: "Notifications", notices: [] },
					{ val: "settings", key: "Settings", notices: [] }
				],
			offset: 0,
			posts: [],
			isLoadingPosts: true,
			yourPhotos: [],
			photosOfYou: [],
			albums: [],
			yourVideos: [],
			videosOfYou: [],
			limit: 30
		}

		this.onScroll = this.onScroll.bind(this)
		this.setTab = this.setTab.bind(this)
		this.onPostAdded = this.onPostAdded.bind(this)
	}

	componentDidMount() {
		FakeData.mountState("league", true)
		const _that = this;
		const _type = "L"
		const _list = FakeData.getBlocked({ props: {} }, true, [_type]);
		const system = _list.BlockedBySystem.filter((item, i) => {
			return (item.username === this.props.match.params.id || item.user_id === this.props.match.params.id) && item.user_type === _type;
		})

		const by_you = _list.BlockedByYou.filter((item, i) => {
			return (item.username === this.props.match.params.id || item.user_id === this.props.match.params.id) && item.user_type === _type;
		})

		const for_you = _list.BlockedForYou.filter((item, i) => {
			return (item.username === this.props.match.params.id || item.user_id === this.props.match.params.id) && item.user_type === _type;
		})

		const final_array = system.concat(for_you, by_you);
		const username_array = [];
		final_array.forEach((item, i) => {
			username_array.push(item.username)
			username_array.push(item.user_id)
		})

		const _isBlocked = (FakeData.inArray(this.props.match.params.id, username_array)) ? true : false;
		if (_isBlocked) {
			_that.setState({
				error: true,
				user: { error: true }
			});
		} else {
			window.addEventListener('scroll', this.onScroll);
			//this.getProfileID = setInterval(()=>this.getProfile(),1000)
			this.getProfile()
			this.getStyle(this.props.match.params.id)
			//this.getPosts()
			this.getYourPhotos()
			this.getPhotosOf()
			this.getVideoOf()
			this.getYourVideos()
			document.querySelector("#root").addEventListener('scroll', this.onScroll);
			var params = FakeData.getQueries(this.props.location.search);
			this.setState({ activeTab: this.props.withGuest ? "about" : (params.sInit) ? params.sInit : "about" });
		}
	}

	shouldComponentUpdate(nextProps, nextState) {
		if (this.props.match.params.id !== nextProps.match.params.id || this.props.location.search !== nextProps.location.search) {
			const _that = this
			FakeData.mountState("league", false)
			this.setState({
				team: { id: null },
				id: nextProps.match.params.id
			});

			setTimeout((() => {
				FakeData.mountState("league", true)
				_that.getProfile()
				//_that.getPosts()
				_that.getStyle(nextProps.match.params.id)
				_that.getYourPhotos()
				_that.getPhotosOf()
				_that.getVideoOf()
				_that.getYourVideos()
				var params = FakeData.getQueries(_that.props.location.search);
				_that.setState({ activeTab: _that.props.withGuest ? "about" : (params.sInit) ? params.sInit : "about" });
			}), 1000)

			return true;
		}

		return true
	}

	componentWillUnmount() {
		FakeData.mountState("league", false)
		//window.removeEventListener('scroll', this.onScroll);

		document.querySelector("#root").removeEventListener('scroll', this.onScroll);
		const s = new Trojan.style("league").kill()
	}

	setTab(item) {
		this.setState({
			activeTab: item.val
		})
	}

	getStyle(id) {
		const _that = this
		FakeData.post("/getLeagueStyle.php?auth0", { leagueId: id }, {
			success: ((res) => {
				if (!FakeData.isMounted("league")) {
					return
				}
				const style = res
				const s = new Trojan.style("league").declare(style).run()
				setTimeout((() => {
					_that.getStyle(this.props.match.params.id)
				}), 10000)
			}),
			error: ((err) => {

			})
		})
	}

	getProfile() {
		const _that = this
		const dataTo = {
			user: _that.props.withGuest ? FakeData.guest : FakeData.getData('yoo'),
			leagueId: this.props.match.params.id
		}

		FakeData.post("/getLeagueTournProfile.php?auth0", dataTo, {
			success: ((res) => {
				if (!FakeData.isMounted("league")) {
					return
				}
				if (res.error) {
					_that.setState({
						error: true,
						league: res
					});
				} else {
					if (!_that.props.withGuest) _that.state.tabs[7].notices = _that.getUnreadNotices(res.notices);
					const _user = res;
					_user.type = "L"
					FakeData.setData("user", _user);
					var params = FakeData.getQueries(_that.props.location.search);
					_that.setState({
						league: res,
						tabs: _that.state.tabs
					});
				}
				FakeData.setData("league", res)
				setTimeout((() => {
					_that.getProfile()
				}), 5000)
			}),
			error: ((err) => {
				_that.setState({
					error: true,
					league: { error: true }
				});
			})
		})
	}

	getUnreadNotices = (notices) => {
		const list = []
		FakeData.listify(notices).forEach((item, i) => {
			if (item.context.status === "unread") {
				list.push(item)
			}
		})

		return list;
	}

	getPosts() {
		//console.log("getPosts.php");
		const _that = this
		const dataTo = {
			user: FakeData.getData("yoo"),
			userTo: {
				id: this.state.league.id,
				type: "L"
			},
			clubs: [],
			leagues: [],
			teams: [],
			limit: this.state.limit
		}

		FakeData.post("/getPosts.php?auth0", dataTo, {
			success: ((res) => {
				if (!FakeData.isMounted("league")) {
					return
				}
				this.setState({
					posts: res,
					isLoadingPosts: false
				})
				_that.getPostsID = setTimeout((() => {
					_that.getPosts()
				}), 1000)
			}),
			error: ((err) => {

			})
		})
	}

	getYourPhotos() {
		const _that = this
		const dataTo = {
			user: FakeData.getData("yoo"),
			userTo: {
				id: this.state.league.id,
				type: "L",
			}
		}

		FakeData.post("/getPhotos.php?auth0&yours", dataTo, {
			success: ((res) => {
				if (!FakeData.isMounted("league")) {
					return
				}

				//console.log(res)
				_that.setState({
					yourPhotos: res
				})

				FakeData.setData("league_pics", res)

				setTimeout((() => {
					_that.getYourPhotos()
				}), 10000)
			}),
			error: ((res) => {

			})
		})
	}

	getPhotosOf() {
		const _that = this
		const dataTo = {
			user: FakeData.getData("yoo"),
			userTo: {
				id: this.state.league.id,
				type: "L",
			}
		}

		FakeData.post("/getPhotos.php?auth0", dataTo, {
			success: ((res) => {
				if (!FakeData.isMounted("league")) {
					return
				}
				_that.setState({
					photosOfYou: res
				})

				setTimeout((() => {
					_that.getPhotosOf()
				}), 10000)
			}),
			error: ((res) => {

			})
		})
	}

	getYourVideos() {
		const _that = this
		const dataTo = {
			user: FakeData.getData("yoo"),
			userTo: {
				id: this.state.league.id,
				type: "L",
			}
		}

		FakeData.post("/getVideos.php?auth0&yours", dataTo, {
			success: ((res) => {
				if (!FakeData.isMounted("league")) {
					return
				}
				_that.setState({
					yourVideos: res
				})

				FakeData.setData("league_vids", res)

				setTimeout((() => {
					_that.getYourVideos()
				}), 10000)
			}),
			error: ((res) => {

			})
		})
	}

	getVideoOf() {
		const _that = this
		const dataTo = {
			user: FakeData.getData("yoo"),
			userTo: {
				id: this.state.league.id,
				type: "L",
			}
		}

		FakeData.post("/getVideos.php?auth0", dataTo, {
			success: ((res) => {
				if (!FakeData.isMounted("league")) {
					return
				}
				_that.setState({
					videosOfYou: res
				})

				setTimeout((() => {
					_that.getVideoOf()
				}), 10000)
			}),
			error: ((res) => {

			})
		})
	}

	onScroll(e) {
		this.setState({
			offset: document.querySelector("#root").scrollTop
		});
	}

	onPostAdded(post) {
		this.state.posts.unshift(post)
		this.setState({
			posts: this.state.posts
		});
	}

	onSaveSeason() {
		//clearInterval(this.getProfileID)
		//this.getProfileID = setInterval(() => this.getProfile(), 1000)
	}

	getTeamIds = () => {
		const teams = FakeData.listify(this.state.league.teams.current);
		const list = [];
		teams.forEach((item, i) => {
			list.push(item.id)
		})

		return list
	}

	render() {
		if (this.state.league.id === null && !this.state.league.error) {
			return (
				<BannerShimmer />
			);
		}

		if (this.state.league.error) {
			return (
				<Redirect to={{
					pathname: "/account_error",

				}} />
			)
		}

		const { withGuest, user } = this.props;

		if (withGuest) {
			return (
				<div className="tabs team row main_content sp-flex-width" style={{ zIndex: 0, padding: "10px 10px" }}>
					<Helmet
						title={this.state.league.name}
						meta={[
							{ "name": "description", "content": "Description of page" },
							{ property: "og:type", content: "profile" },
							{ property: "og:title", content: this.state.league.name },
							{ property: "og:image", content: this.state.league.image },
							{ property: "og:url", content: FakeData.baseURL + "/#" + this.props.location.pathname + this.props.location.search }
						]}
					/>
					<LeagueBanner league={this.state.league} {...this.props} activeTab={this.state.activeTab} tabs={this.state.tabs} onTabSelect={this.setTab} />
					{((this.state.activeTab != "training") /*&& (this.state.activeTab != "events")*/) &&
						<LeagueSplitView BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} isLeague={true} profile={this.state.league} class="league" offset={this.state.offset}>
							{this.state.activeTab !== "apply" &&
								<div>
									<AboutView BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} profile={this.state.league} type="L" hideTabs="true" state="league" />
								</div>
							}
							{/*this.state.activeTab == "apply" &&
                <ApplicationForm profile={FakeData.guest} {...this.props} withGuest={withGuest} isTeam={true} team={this.state.team} type={"T"} />
            */}
						</LeagueSplitView>
					}
				</div>
			);
		}

		return (
			<div className="tabs league row main_content sp-flex-width" style={{ zIndex: 0, padding: "10px 10px" }}>
				<Helmet
					title={this.state.league.name}
					meta={[
						{ "name": "description", "content": "Description of page" },
						{ property: "og:type", content: "club.profile" },
						{ property: "og:title", content: this.state.league.name },
						{ property: "og:image", content: this.state.league.image },
						{ property: "og:url", content: FakeData.baseURL + "/#" + this.props.location.pathname + this.props.location.search }
					]}
				/>
				<LeagueBanner BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} league={this.state.league} activeTab={this.state.activeTab} tabs={this.state.tabs} onTabSelect={this.setTab} />
				<LeagueSplitView BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} isLeague={true} profile={this.state.league} style={{ marginTop: "0px" }} class="league" offset={this.state.offset}>
					{(this.state.activeTab === "timeline") &&
						<div>
							<GlobalTMForm BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} profile={this.state.league} words={() => {
								const _settings = FakeData.listify(this.state.league.settings).filter((set, i) => {
									return set.sub === "word_restrition"
								});

								if (_settings[0]) {
									return FakeData.nullify(_settings[0]['value']).split(",");
								} else {
									return []
								}
							}} isAdmin={this.state.league.isAdmin} onPostAdded={this.onPostAdded} postToType="L" postToId={this.state.league.id} postToName={this.state.league.name} postToImage={this.state.league.image} />
							<GlobalTMFeeds BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} profile={this.state.league}
								postToType="L"
								words={() => {
									const _settings = FakeData.listify(this.state.league.settings).filter((set, i) => {
										return set.sub === "word_restrition"
									});

									if (_settings[0]) {
										return FakeData.nullify(_settings[0]['value']).split(",");
									} else {
										return []
									}
								}} page={{ id: this.state.league.id, type: "L" }} teams={[]} clubs={[]} leagues={[]} institutions={[]} user={(this.state.league.isAdmin) ? this.state.league : FakeData.getData("yoo")} userType={(this.state.league.isAdmin) ? "L" : "F"} posts={this.state.posts}>
								<EmptyState style={{ background: "#fff" }} isShown={(FakeData.listify(this.state.posts).length === 0 && !this.state.isLoadingPosts) ? true : false} text="No posts were found!" icon="filter_hdr" />
								<LoadingState style={{ background: "#fff" }} isShown={this.state.isLoadingPosts} text={"Loading"} />
							</GlobalTMFeeds>
						</div>
					}
					{(this.state.activeTab === "clubs") &&
						<div>
							<ClubsView BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} league={this.state.league} onSaveSeason={() => this.onSaveSeason()} />
						</div>
					}

					{this.state.activeTab == "notice" &&
						<InternalNoticeCenter BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} notices={this.state.league.notices} profile={this.state.league} type={"C"} />
					}

					{this.state.activeTab == "games" &&
						<Games BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} teams={[]} league={this.state.league.id} />
					}
					{this.state.activeTab == "videos" &&
						<Videos BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} user={(this.state.league) ? this.state.league : FakeData.getData("yoo")} userType={(this.state.league.isAdmin) ? "L" : "F"} author={this.state.league.name} data={{ uploads: this.state.yourVideos, tagged: this.state.videosOfYou }} isAdmin={this.state.league.isAdmin} />
					}
					{this.state.activeTab == "photos" &&
						<Photos BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} user={(this.state.league) ? this.state.league : FakeData.getData("yoo")} userType={(this.state.league.isAdmin) ? "L" : "F"} author={this.state.league.name} data={{ uploads: this.state.yourPhotos, tagged: this.state.photosOfYou, albums: this.state.albums }} isAdmin={this.state.league.isAdmin} />
					}
					{this.state.activeTab == "about" &&
						<div>
							<AboutView BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} profile={this.state.league} type="L" hideTabs="true" state="league" />
						</div>
					}
					{(this.state.activeTab === "stats") &&
						<div>
							<ClubStatsView BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} league={this.state.league} />
						</div>
					}
					{(this.state.activeTab === "settings") &&
						<Settings BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} profile={this.state.league} settings={[
							"General",
							"Messaging",
							"Post Attribution",
							"Notifications",
							"Videos",
							"SPAM",
							"Page Roles"
						]} type="L" state="league" />
					}
				</LeagueSplitView>
			</div>
		);
	}
}

class LeagueBanner extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			croppieEl: null,
			isCropping: false,
			croppie: {},
			img: this.props.league.cropped,
			originalImg: this.props.league.image
		}
	}

	componentWillMount() {
		const croppie = Croppie
	}

	setRef() {
		const _that = this
		this.setState({ isCropping: true })
		setTimeout(() => {
			const opts = {
				viewport: {
					width: 200,
					height: 200,
					type: 'circle'
				},
				enforceBoundary: false,
				boundary: {
					width: 300,
					height: 300
				}
			}

			const el = ReactDOM.findDOMNode(_that.el);
			const elem = $(el)[0];
			//console.log(elem);
			var c = new Croppie(elem, opts);

			c.bind({
				url: _that.state.originalImg
			})

			_that.croppie = c
		}, 500)
	}

	saveCrop() {
		const _that = this
		const opts = {
			type: "base64",
			format: "png",
			size: "original"
		}
		this.croppie.result(opts).then((res) => {
			_that.uploadCropped(res)
		}).catch((err) => {

		})
	}

	uploadCropped(data) {
		console.log("jkhjhj");
		const _that = this
		const dataTo = {
			data: data,
			id: this.props.league.id,
			table: "tourn"
		}

		FakeData.post("/uploadCroppedImg.php?auth0", dataTo, {
			success: ((res) => {
				if (!res.error) {
					_that.setState({
						img: data,
						isCropping: false
					});
				} else {
					_that.setState({
						img: _that.state.originalImg,
						isCropping: false
					});
				}


				_that.croppie.destroy()
			}),
			error: ((err) => {

			})
		})
	}

	getRGB(b) {
		var a;
		if (b && b.constructor === Array && b.length === 3) {
			return b;
		}

		if (a = /rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/.exec(b)) {
			return [parseInt(a[1]), parseInt(a[2]), parseInt(a[3])];
		}

		if (a = /rgb\(\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\%\s*\)/.exec(b)) {
			return [parseFloat(a[1]) * 2.55, parseFloat(a[2]) * 2.55, parseFloat(a[3]) * 2.55];
		}

		if (a = /#([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})/.exec(b)) {
			return [parseInt(a[1], 16), parseInt(a[2], 16), parseInt(a[3], 16)];
		}

		if (a = /#([a-fA-F0-9])([a-fA-F0-9])([a-fA-F0-9])/.exec(b)) {
			return [parseInt(a[1] + a[1], 16), parseInt(a[2] + a[2], 16), parseInt(a[3] + a[3], 16)];
		}

		return (typeof (a) !== "undefined") ? a[jQuery.trim(b).toLowerCase()] : null
	};

	luminance_get(color) {
		var rgb = this.getRGB(color);
		if (!rgb) {
			return null;
		}
		return 0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2];
	}

	getSelectedColor(color) {
		var val = (this.luminance_get(color) > 180) ? "#000" : "#fff"
		const dataTo = {
			bg: color,
			txt: val,
			id: this.props.league.id,
			table: "tourn"
		}

		const _that = this

		FakeData.post("/setColors.php?auth0", dataTo, {
			success: ((res) => {

			}),
			error: ((err) => {

			})
		})
	}

	getFilteredNotices = (arr, data) => {
		const list = [];
		FakeData.listify(data).forEach((item, i) => {
			if (FakeData.inArray(item.actionData.context, arr)) {
				list.push(item)
			}
		})

		return list
	}

	like() {
		const dataTo = {
			user: FakeData.getData("yoo"),
			type: "L",
			contentId: this.props.league.id,
			userOne: { id: this.props.league.id, type: "L" },
			userTwo: null,
			users: this.props.league.roles,
			userType: "F"
		}
		const _that = this

		FakeData.post('/likeContent.php?auth0', dataTo, {
			success: ((res) => {
				FakeData.alert("Done!");
			}),
			error: ((err) => {

			})
		}, true, "", () => { })
	}

	addToShortcuts() {
		const dataTo = {
			userId: FakeData.getData("yoo").id,
			contentType: "L",
			contentId: this.props.league.id,
			contentName: this.props.league.name,
			contentRef: this.props.league.hash,
			contentSearch: "?sInit=about",
			userType: "F"
		}

		const _that = this

		FakeData.post('/createShortcut.php?auth0', dataTo, {
			success: ((res) => {
				FakeData.alert("Done!");
			}),
			error: ((err) => {

			})
		}, true, "", () => { })
	}

	render() {
		return (
			<div className="league-banner" style={{ width: FakeData.width, zIndex: 0, overflowY: 'hidden' }}>
				{this.props.league.isAdmin &&
					<BannerReportView id={this.props.league.id} type={'L'} />
				}
				{this.props.league.isAdmin &&
					<div className="league-banner-edit">
						{!this.state.isCropping && this.is &&
							<i className="material-icons" onClick={() => this.setRef()}>create</i>
						}
						{this.state.isCropping &&
							<i className="material-icons" onClick={() => this.setState({ isCropping: false })}>close</i>
						}
						{this.state.isCropping &&
							<i className="material-icons" onClick={() => this.saveCrop()}>save</i>
						}
						{!this.state.isCropping &&
							<i className="material-icons">format_color_fill<input onChange={(e) => this.getSelectedColor(e.target.value)} type="color" style={{ width: "12px", height: "12px", marginLeft: "-15px", opacity: 0 }} /></i>
						}
					</div>
				}
				<div className="league-banner-info" style={{ marginTop: ((this.props.league.isAdmin) ? "-16px" : "") }}>
					<div className="league-banner-info-content">
						<h2>{this.props.league.name}</h2>
						<ul>
							<li><img src={(this.props.league.color === "#fff") ? ".././images/website_icon_wht.svg" : ".././images/website_icon.svg"} /><span>{this.props.league.website}</span></li>
							<li><img src={(this.props.league.color === "#fff") ? ".././images/mobile_icon_wht.svg" : ".././images/mobile_icon.svg"} /><span>{this.props.league.contactMain}</span></li>
							<li><img src={(this.props.league.color === "#fff") ? ".././images/email_icon_wht.svg" : ".././images/email_icon.svg"} /><span>{this.props.league.email}</span></li>
							<li><img src={(this.props.league.color === "#fff") ? ".././images/checkin_icon_wht.svg" : ".././images/checkin_gry.svg"} /><span>{this.props.league.address}</span></li>
						</ul>
						{!this.props.withGuest &&
							<div className="action-buttons">
								{(!this.props.league.hasShortcut && this.props.league.isAdmin) && <div onClick={this.addToShortcuts.bind(this)}><i className="material-icons">add</i>Add to shortcuts</div>}
								{!this.props.league.isLiked && <div onClick={this.like.bind(this)}><i className="material-icons">thumb_up</i>Like</div>}
								{this.props.league.isLiked && <div onClick={this.like.bind(this)}><i className="material-icons">thumb_down</i>Unlike</div>}
								{!this.props.league.isFollewed && <div onClick={() => { }}><i className="material-icons">turned_in</i>Follow</div>}
								{this.props.league.isFollewed && <div onClick={() => { }}><i className="material-icons">turned_in_not</i>Unfollow</div>}
								{!this.props.league.isAdmin &&
									<div onClick={() => {
										const chat = this.props.league.convo ? this.props.league.convo : {
											otherUser: {
												id: this.props.league.id,
												type: "L",
												...this.props.league
											},
											id: null,
											userOne: FakeData.getData("yoo"),
											userTwo: {
												id: this.props.league.id,
												type: "L",
												...this.props.league
											},
											messages: [],
											last_msg: null,
											unread: 0,
											isYou: true,
											date: null,
											removedByUserOne: false,
											removedByUserTwo: false,
											type: "timeline",
											target: "new"
										}

										FakeData.shared("mainThread").addToChats(chat)
									}}><i className="material-icons">chat</i>Message</div>
								}
								<div>
									<FeedBackPopUp isBanner={true} userTo={{
										id: FakeData.getData("yoo").id,
										type: "F"
									}} user={{
										id: this.props.league.id,
										type: "I"
									}} object={{
										id: this.props.league.id,
										type: "I",
										content: this.props.league.name,
										image: this.props.league.image
									}} owner={{
										id: this.props.league.id,
										type: "I",
										name: this.props.league.name,
										user: this.props.league.username,
										image: this.props.league.image,
										email: this.props.league.email,
										roles: this.props.league.roles
									}} text={"More"} iconStyle={{
										margin: "0px 0px 0px 10px",
									}} icon={"more_horiz"} style={{
										display: 'flex'
									}} menus={this.props.league.isAdmin ? {
										Setting: {
											label: "Timeline Settings", cb: () => {
												this.props.onTabSelect(
													{ val: "settings", key: "Settings", notices: [] }
												);
											}
										}
									} : {
											FeedBack: { label: "Report Profile", cb: () => { } },
											Block: { label: "Block", cb: () => { } }
										}} />
								</div>
							</div>
						}
					</div>
					{this.state.isCropping &&
						<div ref={(c) => { this.el = c }} className="league-banner-info-logo" style={{ background: "url(" + this.state.originalImg + ")", backgroundSize: "contain", backgroundPositionX: "0px", backgroundPositionY: "0px" }}>

						</div>
					}
					{!this.state.isCropping &&
						<div className="league-banner-info-logo" style={{ background: "url(" + this.state.img + ")", backgroundSize: "contain", backgroundPositionX: "0px", backgroundPositionY: "0px" }}>
							{!this.props.withGuest && <i className="material-icons">camera_alt</i>}
						</div>
					}
					<div className="league-banner-info-teams">
						{
							this.props.league.teams.current.map((item, i) => {
								if (i > 18) {
									return null
								}

								return (<div key={i} className="league-banner-info-teams-team"><img src={item.image} /></div>)
							})
						}
						{this.props.league.teams.current.length > 19 &&
							<div className="league-banner-info-teams-team"><img src=".././images/next_arrow.svg" /></div>
						}
					</div>
				</div>
				<div className="league-banner-nav">
					{
						this.props.tabs.map((item, i) => {
							if (FakeData.inArray(item.val, ["notice", "training", "events", "settings"]) && !this.props.league.isAdmin) {
								return null;
							}

							if (!this.props.league.hasCurrentSeasonStarted && item.val === "stats") {
								return null;
							}

							return (
								<div className={(this.props.activeTab == item.val) ? "active" : ""} key={i} onClick={() => this.props.onTabSelect(item)}>
									{item.key}
									{(item.notices.length > 0 && this.props.league.isAdmin) &&
										<div className="notices-badge">
											{this.getFilteredNotices(["event_invite", "event_admin_invite", "event_accept"], item.notices).length > 0 &&
												<span className="events">{this.getFilteredNotices(["event_invite", "event_admin_invite", "event_accept"], item.notices).length}</span>
											}
											{this.getFilteredNotices([], item.notices).length > 0 &&
												<span className="_training">{this.getFilteredNotices([], item.notices).length}</span>
											}
											{this.getFilteredNotices(["game_invite", "game_accept"], item.notices).length > 0 &&
												<span className="games">{this.getFilteredNotices(["game_invite", "game_accept"], item.notices).length}</span>
											}
											<span className="all">{item.notices.length}</span>
										</div>
									}
								</div>
							)
						})
					}
				</div>
			</div>
		);
	}
}

export class ClubsView extends Component {
	constructor(props) {
		super(props)
		this.state = {
			activeTab: ((this.props.league.teams.current.length !== 0 && this.props.league.hasCurrentSeasonStarted) ? "current" : ((this.props.league.hasCurrentSeason) ? "manage" : "create")),
			tabs: [
				{ key: "current", val: "Current Clubs" },
				{ key: "past", val: "Past Clubs" },
				{ key: "manage", val: "Manage Seasons" },
				{ key: "create", val: "Create Season" }
			],
			isStartingSeason: false,
			isEdittingTeams: false,
			isEndingSeason: false,
			seasonStartError: false,
			seasonEndError: false,
			startDate: ((this.props.league.hasCurrentSeasonStarted) ? this.props.league.startDate : ""),
			endDate: ""
		}
	}

	onSaveSeason() {
		this.setState({
			activeTab: "manage"
		});

		this.props.onSaveSeason()
	}

	startSeason() {
		const _that = this
		const dataTo = {
			league: this.props.league
		}

		FakeData.post("/startSeason.php?auth0", dataTo, {
			success: ((res) => {
				//console.log(res);
				_that.setState({
					isStartingSeason: false
				});
			}),
			error: ((err) => {

			})
		}, true, "Season Started", ((data) => {

		}))
	}

	endSeason() {
		const _that = this
		const dataTo = {
			league: this.props.league
		}

		FakeData.post("/endSeason.php?auth0", dataTo, {
			success: ((res) => {
				//console.log(res);
				_that.setState({
					isEndingSeason: false
				});
			}),
			error: ((err) => {

			})
		}, true, "Season Ended", ((data) => {

		}))
	}

	onSeasonStartDateChange(d) {
		var newDateToo = new Date(d).getTime()
		if (Date.now() >= newDateToo) {
			this.setState({
				seasonStartError: true,
				startDate: d
			});
		} else {
			const _that = this
			const dataTo = {
				leagueId: this.props.league.id,
				field: "StartDate",
				date: d
			}
			FakeData.post("/updateLeagueDates.php?auth0", dataTo, {
				success: ((res) => {
					_that.setState({
						seasonStartError: false,
						startDate: d
					});
				}),
				error: ((err) => {

				})
			})
		}
	}

	onSeasonEndDateChange(d) {
		var newDateToo = new Date(d).getTime()
		var startDate = new Date(this.state.startDate).getTime()
		if (Date.now() >= newDateToo || startDate >= newDateToo) {
			this.setState({
				seasonEndError: true,
				endDate: d
			});
		} else {
			const _that = this
			const dataTo = {
				leagueId: this.props.league.id,
				field: "EndDate",
				date: d
			}
			FakeData.post("/updateLeagueDates.php?auth0", dataTo, {
				success: ((res) => {
					_that.setState({
						seasonEndError: false,
						endDate: d
					});
				}),
				error: ((err) => {

				})
			})

		}
	}

	render() {
		return (
			<div className="clubs-view" style={{}}>
				<div className="clubs-view-tabs">
					{
						this.state.tabs.map((item, i) => {
							if ((this.props.league.teams.current.length === 0) && (item.key === "current")) {
								return null
							} else if ((this.props.league.seasons.length === 0) && (item.key === "past")) {
								return null
							} else if ((this.props.league.hasCurrentSeason) && (item.key === "create")) {
								return null
							} else if ((!this.props.league.hasCurrentSeason) && (item.key === "manage")) {
								return null
							} else {
								return (
									<div key={i} className={(this.state.activeTab === item.key) ? "clubs-view-tab active" : "clubs-view-tab"} onClick={() => this.setState({ activeTab: item.key })}>{item.val}</div>
								)
							}
						})
					}
				</div>
				<div className="clubs-view-views">
					{(this.state.activeTab === "current") &&
						<div className="clubs-view-view club-list">
							{
								this.props.league.teams.current.map((item, i) => {
									return (
										<ClubItem key={i} team={item} />
									)
								})
							}
						</div>
					}
					{(this.state.activeTab === "past") &&
						<div className="clubs-view-view club-list">
							<PastClubsView teams={this.props.league.seasons} />
						</div>
					}
					{(this.state.activeTab === "create") &&
						<div className="clubs-view-view">
							<CreateTourn onSaveSeason={() => this.onSaveSeason()} league={this.props.league} isSeason="true" />
						</div>
					}
					{(this.state.activeTab === "manage") &&
						<div className="clubs-view-view">
							{(parseInt(this.props.league.noOfTeams) > this.props.league.teams.current.length) &&
								<div>
									<div className="manage-league-season-input">
										<label style={{ margin: "0px", width: "auto" }}>Start Date</label><input type="date" value={this.props.league.startDate} onChange={(e) => this.onSeasonStartDateChange(e.target.value)} className={(this.state.seasonStartError) ? "error" : ""} />
										<span>to</span>
										<label style={{ margin: "0px", width: "auto" }}>Estimated-End Date</label><input value={this.props.league.endDate} disabled={(this.state.startDate === "") ? true : false} type="date" onChange={(e) => this.onSeasonEndDateChange(e.target.value)} className={(this.state.seasonEndError) ? "error" : ""} />
									</div>
									<ManageItem label="Add/Replace Teams">
										<CreateTourn onSaveSeason={() => this.onSaveSeason()} league={this.props.league} isSeason="true" isManage="true" />
									</ManageItem>
								</div>
							}

							{((parseInt(this.props.league.noOfTeams) === this.props.league.teams.current.length) && (!this.props.league.hasCurrentSeasonStarted && this.state.isEdittingTeams)) &&
								<div>
									<div className="manage-league-season-input">
										<label style={{ margin: "0px", width: "auto" }}>Start Date</label><input type="date" value={this.props.league.startDate} onChange={(e) => this.onSeasonStartDateChange(e.target.value)} className={(this.state.seasonStartError) ? "error" : ""} />
										<span>to</span>
										<label style={{ margin: "0px", width: "auto" }}>Estimated-End Date</label><input value={this.props.league.endDate} disabled={(this.state.startDate === "") ? true : false} type="date" onChange={(e) => this.onSeasonEndDateChange(e.target.value)} className={(this.state.seasonEndError) ? "error" : ""} />
									</div>
									<CreateTourn onSaveSeason={() => {
										this.setState({
											isEdittingTeams: false
										});
									}} league={this.props.league} isSeason="true" isManage="true" />
								</div>
							}

							{((parseInt(this.props.league.noOfTeams) === this.props.league.teams.current.length) && (!this.props.league.hasCurrentSeasonStarted && !this.state.isEdittingTeams)) &&
								<div>
									<h1 style={{ textAlign: "center", fontSize: "20px" }}>All Teams Have Been Set!</h1>
									<h3 style={{ textAlign: "center", fontSize: "16px" }}>You Can Start Your Season Now</h3>
									<button className="button" onClick={() => {
										this.setState({
											isStartingSeason: true
										})
									}}>Start Season</button>
									<h5 style={{ textAlign: "center", fontSize: "16px" }}>OR</h5>
									<button className="button" onClick={() => {
										this.setState({
											isEdittingTeams: true
										})
									}}>Edit Teams</button>
									<ConfirmModal message="Are you sure you want to start this season?<br/>" isOpen={this.state.isStartingSeason} data=""
										onOkay={(data) => {
											this.startSeason()
										}}
										onCancel={() => {
											this.setState({
												isStartingSeason: false
											})
										}} />
								</div>
							}

							{((parseInt(this.props.league.noOfTeams) === this.props.league.teams.current.length) && (this.props.league.hasCurrentSeasonStarted)) &&
								<div>
									<div className="manage-league-season-input">
										<label style={{ margin: "0px", width: "auto" }}>Start Date</label><input disabled="true" type="date" value={this.props.league.startDate} onChange={(e) => this.onSeasonStartDateChange(e.target.value)} className={(this.state.seasonStartError) ? "error" : ""} />
										<span>to</span>
										<label style={{ margin: "0px", width: "auto" }}>Estimated-End Date</label><input value={this.props.league.endDate} type="date" onChange={(e) => this.onSeasonEndDateChange(e.target.value)} className={(this.state.seasonEndError) ? "error" : ""} />
									</div>
									<button className="button" onClick={() => {
										this.setState({
											isEndingSeason: true
										})
									}}>End Season</button>
									<h5 style={{ textAlign: "center", fontSize: "16px" }}>OR</h5>
									<Link to="/gmc" className="button" style={{ display: "block", textAlign: "center" }}>Manage Games</Link>
									<ConfirmModal message="Are you sure you want to end this season?<br/>" isOpen={this.state.isEndingSeason} data=""
										onOkay={(data) => {
											this.endSeason()
										}}
										onCancel={() => {
											this.setState({
												isEndingSeason: false
											})
										}} />
								</div>
							}
						</div>
					}
				</div>
			</div>
		);
	}
}

export class ClubStatsView extends Component {
	constructor(props) {
		super(props)
		this.state = {
			activeTab: ((this.props.league.type !== "knockout") ? "groups" : "playOffs"),
			tabs: [
				{ key: "groups", val: "Groups" },
				{ key: "playOffs", val: "Play-offs" }
			],
			default: "Group A"
		}
	}

	setTable(index) {
		this.setState({
			default: this.props.league.groups[index].name
		});
	}

	render() {
		this.props.league.groups.forEach((item) => {
			item.teams.sort(function (a, b) {
				return b.name - a.name
			})
		})

		this.props.league.groups.forEach((item) => {
			item.teams.sort(function (a, b) {
				if (b.pts === a.pts) {
					return b.gd - a.gd
				}
				return b.pts - a.pts
			})
		})

		return (
			<div className="clubs-view" style={{ marginTop: "10px" }}>
				<div className="clubs-view-tabs">
					{
						this.state.tabs.map((item, i) => {
							if (this.props.league.type === "league" && item.key === "playOffs") {
								return null
							} else if (this.props.league.type === "knockout" && item.key === "groups") {
								return null
							} else {
								return (
									<div key={i} className={(this.state.activeTab === item.key) ? "clubs-view-tab active" : "clubs-view-tab"} onClick={() => this.setState({ activeTab: item.key })}>{item.val}</div>
								)
							}
						})
					}
				</div>
				<div className="clubs-view-views">
					{(this.state.activeTab === "playOffs" && this.props.league.hasCurrentSeasonStarted) &&
						<PlayOffView playOffs={this.props.league.playOffs} teams={this.props.league.teams.current} className="fe" />
					}
					{(this.state.activeTab === "playOffs" && !this.props.league.hasCurrentSeasonStarted) &&
						<EmptyState isShown={true} text={"No Playoffs yet, make sure you have at least one season started"} />
					}
					{(this.state.activeTab === "groups") &&
						<div className="stand">
							{this.props.league.groups.length === 1 &&
								<div className="stand-tables">
									<GroupStand fe="true" user={FakeData.getData("yoo")} default={this.state.default} group={this.props.league.groups[0]} />
								</div>
							}
							{this.props.league.groups.length > 1 &&
								<div className="stand-tables-group">
									<div className="stand-controls">
										<div className="stand-control-holder">
											{
												this.props.league.groups.map((item, i) =>
													<div key={i} className={(this.state.default === item.name) ? "stand-control active" : "stand-control"} onClick={() => this.setTable(i)}>{item.name}</div>
												)
											}
										</div>
									</div>
									{
										this.props.league.groups.map((group, i) =>
											<GroupGames key={i} default={this.state.default} group={group} />
										)
									}
									{
										this.props.league.groups.map((group, x) =>
											<GroupStand fe="true" user={FakeData.getData("yoo")} key={x} default={this.state.default} group={group} />
										)
									}
								</div>
							}
						</div>
					}
				</div>
			</div>
		);
	}
}

class ManageItem extends Component {
	constructor(props) {
		super(props)
		this.state = {
			isExtended: false
		}
	}

	render() {
		return (
			<div className="manage-item">
				<div onClick={() => {
					this.setState({
						isExtended: (this.state.isExtended) ? false : true
					});
				}}>
					<span>{this.props.label}</span>
					<span><i className="material-icons">{(this.state.isExtended) ? "remove" : "add"}</i></span>
				</div>
				{this.state.isExtended &&
					<div>
						{this.props.children}
					</div>
				}
			</div>
		);
	}
}



export default HomeView;



// WEBPACK FOOTER //
// ./src/pages/LEAGUE.js